import {
  createContext,
  useContext,
  Dispatch,
  SetStateAction,
  useState,
  createElement,
  ReactNode,
} from 'react';

import { ZeroStateProps } from '../../components/ZeroState';

export type ZeroStateContextValue =
  | (ZeroStateProps & {
      key?: string;
    })
  | undefined;
// create a context and provider for zero state
const ZeroStateContext = createContext<ZeroStateContextValue>(undefined);

const ZeroStateDispatch = createContext<
  Dispatch<SetStateAction<ZeroStateContextValue>> | undefined
>(undefined);

// create a hook function to set the zero state
export const useZeroState = () => {
  return useContext(ZeroStateContext);
};

export const useZeroStateDispatch = () => {
  return useContext(ZeroStateDispatch);
};

export interface ZeroStateProviderProps {
  children?: ReactNode;
  initialState?: ZeroStateContextValue;
}

/**
 * Provides a shared zero state context for components that consume this provider. Components can
 * consume and dispatch changes to the zero state using the hooks.
 * This allows different item sources to present different zero state displays
 * @param initialState
 * @param children
 * @constructor
 */
export const ZeroStateProvider = ({
  initialState = undefined,
  children,
}: ZeroStateProviderProps) => {
  const [zeroState, setZeroState] = useState<ZeroStateContextValue>(initialState);
  return (
    <ZeroStateContext.Provider value={zeroState}>
      <ZeroStateDispatch.Provider value={setZeroState}>{children}</ZeroStateDispatch.Provider>
    </ZeroStateContext.Provider>
  );
};
